{
  "home.greeting.morning": "Good morning, {name}",
  "home.greeting.afternoon": "Good afternoon, {name}",
  "home.greeting.evening": "Good evening, {name}",
  "home.scope.company": "Across the company",
  "home.scope.team": "Your team",
  "home.scope.self": "Assigned to you",
  "home.kpi.leads": "Leads",
  "home.kpi.pipeline": "Clients in pipeline",
  "home.kpi.pipelineSplit": "{leads} leads · {calls} calls · {farming} resale",
  "home.kpi.won": "Won / lost",
  "home.kpi.winRate": "{rate}% win rate",
  "home.kpi.noClosed": "Nothing closed yet",
  "home.chart.leads": "New leads per week",
  "home.chart.leadsCaption": "Last 12 weeks, from the {count} leads you can see",
  "home.chart.leadsPoint": "{count, plural, one {# lead} other {# leads}}, week of {week}",
  "home.chart.pipeline": "Deals by stage",
  "home.chart.pipelineCaption": "Where every open and closed deal stands",
  "home.today.title": "Today",
  "home.today.open": "Open calendar",
  "home.today.empty": "A clear day. Plan a call or a viewing from any client.",
  "home.todo.title": "To-do",
  "home.todo.caption": "{count, plural, =0 {All done} one {# open} other {# open}}",
  "home.todo.placeholder": "Add a to-do and press Enter",
  "home.todo.empty": "Nothing on your list.",
  "home.team.title": "Team now",
  "home.team.caption": "{online, plural, =0 {Nobody online} one {# online} other {# online}}",
  "home.team.online": "Online",
  "home.team.never": "Not yet",
  "home.subtitle.company": "Here's how the company is doing today.",
  "home.subtitle.team": "Here's how your team is doing today.",
  "home.subtitle.self": "Here's where your work stands today.",
  "home.glance.next": "Next {time} · {title}",
  "home.glance.doneForToday": "Nothing else coming up",
  "home.glance.clear": "A clear calendar",
  "home.glance.todos": "{done, plural, =0 {Open on your list} other {# done}}",
  "home.glance.online": "Online now",
  "home.glance.people": "{count, plural, one {Of # person} other {Of # people}}",
  "home.flow.title": "Sales flow",
  "home.flow.caption": "From first lead to closed deal",
  "home.flow.converted": "{rate}% converted",
  "home.flow.noWinRate": "No win rate yet",
  "home.kpi.wonOnly": "Closed-won",
  "home.kpi.lost": "{count} lost",
  "home.chart.deals": "{count, plural, one {deal} other {deals}}",
  "home.chart.thisWeek": "this week · avg {usual}",
  "home.flow.prospects": "{calls, plural, one {# cold call} other {# cold calls}} · {farming} resale",
  "home.chart.leadsEmpty": "No new leads in the last 12 weeks",
  "home.journey.title": "Lead journey",
  "home.journey.caption": "{count, plural, one {1 lead} other {# leads}} on the board",
  "home.journey.open": "Open the board",
  "home.journey.soon": "Due in 2 hours",
  "home.journey.rotatedToday": "Rotated today",
  "home.journey.withLeader": "With leaders",
  "home.glance.calls": "Calls today",
  "home.glance.callsYesterday": "{count, plural, =0 {None yesterday} other {# yesterday}}",
  "home.glance.leads": "New leads today",
  "home.glance.leadsWaiting": "{count, plural, =0 {All contacted} one {# waiting for a call} other {# waiting for a call}}",
  "home.pulse.title": "This week so far",
  "home.pulse.caption": "{range}, against the same days last week",
  "home.pulse.open": "Open reports",
  "home.overview.title": "Overview",
  "home.overview.total": "All leads",
  "home.overview.totalCaption": "Every lead in reach",
  "home.overview.fresh": "Fresh",
  "home.overview.following": "Following",
  "home.overview.reservations": "Reservations",
  "home.overview.pool": "Cold calls",
  "home.overview.share": "{percent} of all leads",
  "home.delay.title": "Delay list",
  "home.delay.caption": "{count, plural, =0 {Nothing late} one {# lead needs someone now} other {# leads need someone now}}",
  "home.delay.board": "Open board",
  "home.delay.tabs": "Late leads by status",
  "home.delay.all": "All",
  "home.delay.col.lead": "Lead",
  "home.delay.col.since": "On this status since",
  "home.delay.noComment": "No comment yet",
  "home.delay.empty": "Nobody is late. Every timer has time left.",
  "home.delay.emptyStatus": "Nobody is late on {status}.",
  "home.delay.more": "{count, plural, one {# more on the board} other {# more on the board}}",
  "home.followUp.title": "To do today",
  "home.followUp.caption": "Leads with a call, WhatsApp or note today, by status",
  "home.followUp.figure": "done",
  "home.followUp.count": "{done} of {total} · {percent}",
  "home.followUp.total": "Total",
  "home.followUp.empty": "No leads on a timed status.",
  "home.comments.title": "Last comments",
  "home.comments.caption": "The newest calls, chats and notes, last 7 days",
  "home.comments.empty": "No comments in the last 7 days.",
  "home.creation.title": "Client creation",
  "home.creation.caption": "New leads per day, last {days} days",
  "home.creation.figure": "new leads",
  "home.creation.point": "{count, plural, one {# lead} other {# leads}} on {day}",
  "home.createdToday.title": "Created today",
  "home.createdToday.figure": "today",
  "home.createdToday.empty": "No new leads yet today.",
  "home.createdToday.more": "{count, plural, one {# more} other {# more}}"
}
